/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { isMobile } from "react-device-detect";
import {
 Line, Center, Row, Grid, Icon, LabelBig, Label, IconSmall, Question
} from 'meitav-uikit';
import { Parser } from 'html-to-react';

export default function QuestionFooter({
  text,
  whyImportant,
  tooltip,
  stepActive,
  icon,iconUp,iconDown
}) {
  const p = new Parser();
  const [openTooltip, setOpenTooltip] = useState(false);
  const [firstLoad, setFirstLoad] = useState("");

  if (firstLoad != stepActive) {
    setOpenTooltip(false);
    setFirstLoad(stepActive);
  }

  const clickTootlip = () => {
    setOpenTooltip(!openTooltip);
  };
  return (
    <>
     {text &&(<Label text={p.parse(text)}></Label>)}
      {whyImportant &&
        <Question text={p.parse(tooltip)} title={p.parse(whyImportant)}/>
      }
    </>
  );
}
